import {configureStore} from "scholastic-client-components/src/SharedPackages/reduxToolkit"
import {formErrorMiddleware} from "scholastic-client-components/src/middlewares/formErrorMiddleware"
import {getStoreWatchers} from "scholastic-client-components/src/middlewares/reduxMiddlewares"
import {rootReducer} from "./rootReducer"

export const store = configureStore({
    reducer: rootReducer,
    middleware: [...getStoreWatchers(), formErrorMiddleware.middleware],
})